import {Button} from "@fluentui/react-components";
import {BiArrowBack} from "react-icons/bi";

function BackButton() {
    return (
        <div>
            <Button as={`a`} className={`button`} onClick={async () => {window.history.back()}}><BiArrowBack/> Terug</Button>
        </div>
    );
}

export default BackButton;